<template>
  <div class="payment-list">
    <MatterPageList :list="list">
      <template v-slot:list-prview="{ item }">
        <slot name="item-prview" v-bind:item="item" >
          <FrontageLink :to="navigateTo" :params="{uid: item.uid, origin: 'Client card payments tab'}" >
            <MatterPaymentRow
              :payment="item"
              :showStaff="isMultipleStaffs" />
          </FrontageLink>
        </slot>
      </template>
    </MatterPageList>
    <InfiniteScroll
      @on-scroll="loadMore"
      :is-empty="isEmpty"
      :identifier="refreshId"
      :no-result-txt="$t('client.matters.matter_page.payments_tab.no_items_found')" />
  </div>
</template>

<script>
import {InfiniteScroll, FrontageLink} from "@/modules/common/components"
import MatterPaymentRow from "@/modules/matters/components/MatterPaymentRow/MatterPaymentRow"
import MatterPageList from '@/modules/matters/components/matterPageList/MatterPageList'

export default {
  name: "PaymentList",
  components: {
    InfiniteScroll,
    MatterPageList,
    MatterPaymentRow,
    FrontageLink,
  },
  props: {
    page: {
      type: String,
      required: true
    },
    listName: {
      type: String,
      required: true
    },
    setPage: {
      type: String,
      required: true
    },
    loadData: {
      type: String,
      required: true
    },
    getterCompleted: {
      type: String,
      required: true
    },
    refreshId: {
      type: Number,
      required: true
    },
    navigateTo: {
      type: String,
      required: true
    }
  },
  computed: {
    isMultipleStaffs() {
      return this.$store.getters['accountModule/isMultipleStaffs']
    },
    currContact() {
      return this.$store.getters['mattersModule/currContact']
    },
    list() {
      return this.$store.getters["mattersModule/" + this.listName]
    },
    currPage() {
      return this.$store.getters['mattersModule/' + this.page]
    },
    isCompleted() {
      return this.$store.getters['mattersModule/' + this.getterCompleted]
    },
    isEmpty(){
      return this.isCompleted && this.list.length === 0
    },
  },
  methods: {
    async loadMore($state) {
      const page = this.currPage
      this.$store.commit("mattersModule/" + this.setPage, page + 1)
      await this.$store.dispatch({type: "mattersModule/" + this.loadData})
      if (this.isCompleted) {
        $state.complete();
        return
      }

      $state.loaded();
    },
  }
}
</script>

<style lang="scss" scoped>
.payment-list {
  align-items: stretch;
  width: 100%;
  overflow: auto;
  flex: 1;
}
</style>
